// src/components/ScoreboardAdmin/ScoreComponent.jsx
import React, { useRef, useState } from "react";

/**
 * Compteur de points:
 * - Bouton principal très lisible (clic = +1)
 * - Appui long (0.5s) = -1
 * - Support souris & touch
 * - Applique Waza-ari awasete Ippon si activé
 */
const ScoreComponent = ({
  competiteur,
  score,
  setScore,
  tapisId,
  isRed,
  wazariAwaseteIppon,
}) => {
  const pressRef = useRef(null);
  const [isLongPress, setIsLongPress] = useState(false);

  const update = (type, inc = true) => {
    setScore((prev) => {
      const next = Math.max(0, (prev[type] || 0) + (inc ? 1 : -1));
      let updated = { ...prev, [type]: next };

      if (wazariAwaseteIppon && type === "wazari" && updated.wazari >= 2 && (updated.ippon || 0) === 0) {
        updated = { ...updated, ippon: (updated.ippon || 0) + 1, wazari: 0 };
      }
      return updated;
    });
  };

  const startLong = (type) => {
    setIsLongPress(false);
    pressRef.current = setTimeout(() => {
      setIsLongPress(true);
      update(type, false);
    }, 500);
  };

  const endLong = () => {
    if (pressRef.current) {
      clearTimeout(pressRef.current);
      pressRef.current = null;
    }
  };

  const bigBtnClass =
    "w-full h-20 sm:h-24 rounded-xl bg-slate-200 text-slate-900 dark:bg-slate-100 dark:text-slate-900 " +
    "text-4xl sm:text-5xl font-extrabold flex items-center justify-center select-none shadow-inner";

  const tileClass = `rounded-2xl p-3 sm:p-4 ${isRed ? "bg-red-600 text-white" : "bg-white text-slate-900"} shadow`;

  const Title = ({ children }) => (
    <p className="uppercase tracking-wide text-xs sm:text-sm font-extrabold opacity-90 mb-1">{children}</p>
  );

  return (
    <div className={tileClass}>
      {/* Nom (discret) */}
      <div className="text-xs sm:text-sm font-semibold mb-2 opacity-90 truncate">
        {competiteur?.nom_competiteur?.toUpperCase()} {competiteur?.prenom_competiteur}
      </div>

      <div className="grid grid-cols-3 gap-3 sm:gap-4">
        {["ippon", "wazari", "yuko"].map((k) => (
          <div key={k} className="flex flex-col items-stretch">
            <Title>{k}</Title>
            <button
              className={bigBtnClass}
              onClick={() => {
                if (!isLongPress) update(k, true);
                setIsLongPress(false);
              }}
              onMouseDown={() => startLong(k)}
              onMouseUp={endLong}
              onMouseLeave={endLong}
              onTouchStart={() => startLong(k)}
              onTouchEnd={endLong}
            >
              {score[k] || 0}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScoreComponent;
